const FormatNumberVisible = (phoneNumber: string | undefined) => {
  // Telefon numarasının başındaki +90 kodunu kaldır
  if (phoneNumber?.startsWith("+9")) {
    phoneNumber = phoneNumber?.slice(2);
  }

  // Numarayı istenen formata dönüştür
  let formattedNumber = phoneNumber?.replace(
    /(\d{4})(\d{3})(\d{2})(\d{2})/,
    "$1 $2 $3 $4"
  );

  return formattedNumber || "**********;";
};

export default FormatNumberVisible;
